import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import OptimizedImage from './OptimizedImage';
import GetStartedToolTile from './GetStartedToolTile';
import find from 'lodash/find';
import { useFptiImpression } from '../../../lib/hooks';

const GetStarted = ({
  fptiImpression,
  fptiClick,
  content,
  appIntents,
  categories,
  tools,
  toolTileProps
}) => {
  if (!content || !appIntents || appIntents.length < 1) return null;

  const {
    categoryBody,
    categoryHeader,
    categoryImageUrl,
    categoryTitle,
    categoryFPTI
  } = content;
  const categoriesArr = Object.values(categories);
  const toolsArr = Object.values(tools);
  const ref = useRef();
  useFptiImpression(ref, () => {
    fptiImpression({
      pageLink: categoryFPTI,
      category: 'parent'
    });
  });

  const renderGetStartedTools = () => {
    return appIntents.map(sortedTool => {
      const getStartedTool =
        find(toolsArr, obj => obj.appKey === sortedTool.appKey) || {};
      const getStartedCategory = find(
        categoriesArr,
        obj => obj.categoryKey === getStartedTool.categoryKey
      );
      if (getStartedCategory === undefined) {
        return null;
      }
      return (
        <GetStartedToolTile
          category={getStartedCategory}
          fptiClick={fptiClick}
          fptiImpression={fptiImpression}
          pageLink={content.categoryFPTI}
          tool={getStartedTool}
          toolTileProps={toolTileProps}
        />
      );
    });
  };

  return (
    <section id="appcenter-get-started">
      <div className="get-started-container">
        <div className="get-started-header">
          <h1 className="get-started-heading">{categoryTitle}</h1>
        </div>
        <div className="get-started-wrapper">
          <div className="get-started-row">
            <div className="get-started-col-left">
              <div className="get-started-content" ref={ref}>
                <div className="get-started-content-text">
                  <h2 className="get-started-content-heading">
                    {categoryHeader}
                  </h2>
                  <h4 className="get-started-content-subheading">
                    {categoryBody}
                  </h4>
                </div>
                <div className="get-started-content-media">
                  <OptimizedImage
                    imageUrl={categoryImageUrl}
                    className={'get-started-content-image'}
                  />
                </div>
              </div>
            </div>
            <div className="get-started-col-right">
              <div className="get-started-inner">
                <div className="get-started-grid">
                  {renderGetStartedTools()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

GetStarted.propTypes = {
  fptiClick: PropTypes.func,
  fptiImpression: PropTypes.func,
  content: PropTypes.object,
  appIntents: PropTypes.array,
  categories: PropTypes.object,
  tools: PropTypes.object,
  toolTileProps: PropTypes.object
};

export default GetStarted;
